<template>
  <div :class=" `gb-zb-msg ${content.from === 'guest' ? 'gb-zb-msg-right' : 'gb-zb-msg-left' }` ">
    <div  v-html="parsedContent">
    </div>
    <span class="chawgt-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import Urls from 'my-name-is-url'

import BaseMessage from '@/layout/messages/BaseMessage.vue'

export default {
  name: 'ContentTxt',
  extends: BaseMessage,
  computed: {
    parsedContent () {
      return Urls(this.content.txt).filter(url => `<a href="${url}">${url}</a>`)
    }
  }
}

</script>

<style lang="scss" scoped>
div {
  word-wrap: break-word;
}

span.chawgt-msg-date {
  clear: both;
  display: block;
  font-size: 0.7rem !important;
  text-align: right;
}
</style>
